import { AuthErrorField, AuthErrorKind } from '@griply/types';

const FIELD_BY_KIND = new Map<AuthErrorKind, AuthErrorField>([
  [AuthErrorKind.InvalidEmail, AuthErrorField.Email],
  [AuthErrorKind.EmailTaken, AuthErrorField.Email],
  [AuthErrorKind.WeakPassword, AuthErrorField.Password],
]);

export const getAuthErrorField = (kind: AuthErrorKind): AuthErrorField =>
  FIELD_BY_KIND.get(kind) ?? AuthErrorField.Form;
